import { render, staticRenderFns } from "./model-pageHead.vue?vue&type=template&id=37d2a18e&scoped=true&"
import script from "./model-pageHead.vue?vue&type=script&lang=js&"
export * from "./model-pageHead.vue?vue&type=script&lang=js&"
import style0 from "./model-pageHead.vue?vue&type=style&index=0&id=37d2a18e&lang=scss&scoped=scoped&"
import style1 from "./model-pageHead.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2a18e",
  null
  
)

export default component.exports